import { routeMain as routeArchitecturePage } from "components/pages/ArchitecturePage";
import { Link } from "react-router-dom";

import Tree from "./Three";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AppContext } from "components/AppContext/AppContext";
import { getProjects } from "utils/getProjects";

import styles from "./styles.module.scss";
// import Spiner from "components/ServiceСomponents/Spiner";

const PortfolioSection = () => {
  const serverUrl = "http://193.222.62.132:1337";
  const { projects, setProjects } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          serverUrl + "/api/projects?component=*&populate=deep"
        );
        // console.log(response);
        // debugger;
        // setProjects(getProjects(response.data.data));
        setProjects(getProjects(response.data.data[0].attributes.project));
      } catch (error) {
        console.error("Error fetching projects:", error);
        return false;
      }
    }

    if (projects.length === 0) {
      fetchData();
    } else {
      setIsLoading(false);
    }
  }, [projects, setProjects]);

  return isLoading ? (
    // <Spiner />
    <></>
  ) : (
    <section className={styles.root}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.performance}>
            {/* <div className={styles.left}> */}
            <p className={styles.works}>НАШИ ВЫПОЛНЕННЫЕ РАБОТЫ</p>
            <Link to={routeArchitecturePage()}>
              <h2 className={styles.title}>КОМПЛЕКСНОЕ ПРОЕКТИРОВАНИЕ</h2>
            </Link>
            <Link
              to={routeArchitecturePage()}
              className={`${styles.get} ${styles.right}`}
            >
              ВСЕ РАБОТЫ
            </Link>
          </div>
          <div className={styles.outputThree}>
            <Tree list={projects} />
          </div>

          <Link
            to={routeArchitecturePage()}
            className={`${styles.get} ${styles.down}`}
          >
            ВСЕ РАБОТЫ
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;

// <div className={styles.trio}>
//  <div>
//    <picture>
//      {/* <source srcSet={link1_1920} media="(max-width: 1280px)" />
//              <source srcSet={link1_1280} media="(max-width: 800px)" /> */}
//      <img
//        src={link1_1920}
//        className={styles.bigImg}
//        alt="Банный комплекс 'Карелия"
//      />
//    </picture>
//    <h3 className={styles.coment1}>Банный комплекс "Карелия"</h3>
//    <p className={styles.coment2}>Здания, фасады, благоустройство</p>
//  </div>
//  <div className={styles.two}>
//    <div>
//      <picture>
//        {/* <source srcSet={link2_1920} media="(max-width: 1280px)" />
//                <source srcSet={link2_1280} media="(max-width: 800px)" /> */}
//       <img
//         src={link2_1920}
//          className={styles.smolImg}
//          alt="Санаторий Таежный"
//        />
//      </picture>
//     <h3 className={styles.coment1}>Санаторий Таежный</h3>
//      <p className={styles.coment2}>Здания, фасады, благоустройство</p>
//    </div>
//    <div>
//      <picture>
//        {/* <source srcSet={link3_1920} media="(max-width: 1280px)" />
//                <source srcSet={link3_1280} media="(max-width: 800px)" /> */}
//        <img
//         src={link3_1920}
//          className={styles.smolImg}
//          alt="Институт им. Хлопина"
//        />
//      </picture>
//      <h3 className={styles.coment1}>Институт им. Хлопина</h3>
//      <p className={styles.coment2}>Здания, фасады, благоустройство</p>
//    </div>
//  </div>
//</div>;

// const list = [
//   {
//     id: 1,
//     title: 'Банный комплекс "Карелия"',
//     description: "Здания, фасады, благоустройство",
//     banerAlt: "Банный комплекс 'Карелия",
//     baner: `${link1_1920}`,
//   },
//   {
//     id: 2,
//     title: "Санаторий Таежный",
//     description: "Здания, фасады, благоустройство",
//     banerAlt: "Санаторий Таежный",
//     baner: `${link2_1920}`,
//   },
//   {
//     id: 3,
//     title: "Институт им. Хлопина",
//     description: "Здания, фасады, благоустройство",
//     banerAlt: "Институт им. Хлопина",
//     baner: `${link3_1920}`,
//   },
// ];
